import { selectMainWallet } from "@/entities/community"
import { useAppSelector } from "@/shared/lib/redux"
import { PageHeader } from "@/widgets/page-header"
import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { BonusWallet } from "@/widgets/bonus-wallet"
import { selectAvailableBonuses, selectBonusesLoading } from "@/entities/bonus"
import { useCreateInvoiceModal } from "@/features/create-invoice"

export const BonusListPage = () => {
    const wallet = useAppSelector(selectMainWallet)
    const bonuses = useAppSelector(selectAvailableBonuses)
    const bonusesLoading = useAppSelector(selectBonusesLoading)
    const { openCreateInvoiceModal } = useCreateInvoiceModal()

    return (
        <div className="_page_container">
            <PageHeader title="Бонусы" />
            <div className="flexbox">
                <PageSubtitle 
                    title={
                        <div className="w-full flex items-center justify-between">
                            <div>
                                Кошелек
                            </div>
                            <button 
                                onClick={() => openCreateInvoiceModal()}
                                className="cursor-pointer hover:text-slate-100 transition-all"
                            >
                                Пополнить
                            </button>
                        </div>
                    } 
                />
                <BonusWallet bonuses={bonuses} bonusesLoading={bonusesLoading} wallet={wallet} />
            </div>
        </div>
    )
}